// Models
import { PlanType } from "@ms/uno-constants/lib/local/AppConstants";
import { TeamsChannelType } from "@ms/uno-constants/lib/local/TeamsConstants";
import { ContainerType } from "../service/planner/enumerations/IPlannerEnumerations";
// Utilities
import { buildTeamsChannelContainerId } from "@ms/uno-utilities/lib/local/TeamsUtilities";
/**
 * Whether the plan supports EVO calendar settings, independently of user permissions and feature flights.
 */ export const isPlanCalendarEligible = (plan)=>{
    const containerType = plan.container.containerType;
    return containerType !== ContainerType.ToDo && containerType !== ContainerType.Project;
};
/**
 * Helper function to check whether the container type of a plan is shared
 * @param containerType The container type of the plan to check
 */ export const isSharedContainer = (containerType)=>{
    return containerType === ContainerType.Group || containerType === ContainerType.Roster || containerType === ContainerType.TeamsChannel;
};
/**
 * Helper function to get the plan type for a given container type
 * @param containerType The container type to check
 */ export const getPlanTypeForContainer = (containerType)=>{
    switch(containerType){
        case ContainerType.Group:
            return PlanType.Unified;
        case ContainerType.Roster:
        case ContainerType.User:
            return PlanType.Basic;
        case ContainerType.Project:
            return PlanType.Premium;
        case ContainerType.ToDo:
        case ContainerType.PlannerTask:
            return PlanType.ToDo;
        default:
            return PlanType.Basic;
    }
};
export const getContainerForTeamsChannelType = (channelType, groupId, channelId)=>{
    switch(channelType){
        case TeamsChannelType.Standard:
            return {
                containerType: ContainerType.Group,
                containerId: groupId
            };
        default:
            return {
                containerType: ContainerType.TeamsChannel,
                containerId: buildTeamsChannelContainerId(groupId, channelId)
            };
    }
};
/**
 * Map of v4 "internal name" values to their normalized ContainerType values
 * "officeDocument" -> driveItem
 * "meeting" -> onlineMeeting
 * "dataverseProject" -> project
 */ const containerTypeNormalizationMap = {
    officeDocument: ContainerType.DriveItem,
    meeting: ContainerType.OnlineMeeting,
    dataverseProject: ContainerType.Project
};
/**
 * Normalizes a ContainerType string (adjust for v4 "internal name" values getting mapped to correct string values)
 * "officeDocument" -> driveItem
 * "meeting" -> onlineMeeting
 * "dataverseProject" -> project
 * @param value The ContainerType string value
 * @returns The normalized ContainerType
 */ export const normalizeContainerType = (value)=>{
    const normalizedValue = containerTypeNormalizationMap[value];
    if (normalizedValue) {
        return normalizedValue;
    }
    return value;
};
